module.exports = __webpack_public_path__ + "static/Santiago-Jimenez-5f54e7c6c3a624686db841344a47049d.png";